// extracted by mini-css-extract-plugin
export default {"row":"Commands_row__JrOOY","center":"Commands_center__1xD-E","button":"Commands_button__0orFF","table":"Commands_table__n21Qw"};